import React from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components/macro';
import { spacing02, spacing04 } from '../../../../../styling/spacing';

type Props = {
  type: string;
};
export const TargetHandle = () => {
  return <InvisibleHandle type="target" position={Position.Left} isConnectable={false} />;
};

export const SourceHandle = () => {
  return <InvisibleHandle type="source" position={Position.Right} isConnectable={false} />;
};

const InvisibleHandle = styled(Handle).attrs(props => ({ type: props.type }))<Props>`
  top: ${spacing04};
  left: -${spacing02};
  border-radius: 0;
  border: 1px solid black;
`;
